var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76655 4.90884H8.11355V3.42584H2.17055C2.10655 3.42584 2.05555 3.37384 2.05555 3.31084C2.05555 3.24784 2.10755 3.19584 2.17055 3.19584H7.73855V2.96484H2.11055C1.80655 2.96484 1.56055 3.21084 1.56055 3.51484V7.48784C1.56055 7.79184 1.80655 8.03784 2.11055 8.03784H8.11455V6.55684H6.76755V4.90984L6.76655 4.90884Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99805 6.32367H8.43905V5.13867H6.99805V6.32367ZM7.44905 5.55367C7.54205 5.55367 7.61705 5.62867 7.61705 5.72067C7.61705 5.81267 7.54205 5.88767 7.44905 5.88767C7.35605 5.88767 7.28205 5.81267 7.28205 5.72067C7.28205 5.62867 7.35705 5.55367 7.44905 5.55367Z",
    fill: "#004C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51513 4.73945V3.02645H8.13913V2.56445H2.11113C1.58713 2.56445 1.16113 2.99045 1.16113 3.51445V7.48745C1.16113 8.01145 1.58713 8.43745 2.11113 8.43745H8.51513V6.72445H8.83913V4.73945H8.51513ZM8.63913 6.52445H8.31513V8.23745H2.11113C1.69813 8.23745 1.36113 7.90145 1.36113 7.48745V3.51345C1.36113 3.10045 1.69713 2.76345 2.11113 2.76345H7.93913V3.22545H8.31513V4.93845H8.63913V6.52345V6.52445Z",
    fill: "#091E0E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBalance);
export default __webpack_public_path__ + "static/media/MyBalance.68cb9f25b9aa2f4b6d554dde7b19d8df.svg";
export { ForwardRef as ReactComponent };